export class LogLevel {

    static readonly ALL: LogLevel = {level: 0, name: 'ALL'};
    static readonly DEBUG = {level: 200, name: 'DEBUG'};
    static readonly INFO = {level: 300, name: 'INFO'};
    static readonly WARNING = {level: 400, name: 'WARNING'};
    static readonly ERROR = {level: 500, name: 'ERROR'};
    static readonly OFF = {level: Number.MAX_SAFE_INTEGER, name: 'OFF'};

    constructor(
        public level: number,
        public name: string) {
    }
}
